module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAKCAYAAACe5Y9JAAAAGklEQVQImWOUn3fmAwMDgzwTAxRQhcHAwAAA5NcCrMckoFcAAAAASUVORK5CYII="